export default {"src":"/_next/static/media/usdt-token.dcef1ab2.svg","height":295,"width":339};